const ajax = {
  get: (action, data = {}, options = {}) => {
    let url = `${digiteketData.ajaxUrl}?action=${action}`;

    data = {
      nonce: digiteketData.nonce,
      ...data,
    };

    options = {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
      ...options,
    };

    const query = [];

    for (const [key, value] of Object.entries(data)) {
      query.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    }

    if (query.length) {
      url += "&" + query.join("&");
    }

    return fetch(url, options).then((response) => {
      if (response.status < 200 || response.status >= 400) {
        throw response;
      }

      return response.json();
    });
  },

  post: (action, data = {}, options = {}) => {
    data = {
      action,
      nonce: digiteketData.nonce,
      ...data,
    };

    const body = [];

    for (const [key, value] of Object.entries(data)) {
      body.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    }

    options = {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: body.join("&"),
      ...options,
    };

    return fetch(digiteketData.ajaxUrl, options).then((response) => {
      if (response.status < 200 || response.status >= 400) {
        throw response;
      }

      return response.json();
    });
  },

  refreshNonce: () => {
    return ajax.get("digiteket_refresh_nonce").then((response) => {
      if (response.success && response.data) {
        if (typeof response.data.nonce === "string") {
          window.digiteketData.nonce = response.data.nonce;
        }

        if (typeof response.data.logoutUrl === "string") {
          window.digiteketData.logoutUrl = response.data.logoutUrl;
        }
      }

      return response;
    });
  },
};

export default ajax;
